import { render, staticRenderFns } from "./IntervalDetailsTable.vue?vue&type=template&id=484bee50&scoped=true&"
import script from "./IntervalDetailsTable.vue?vue&type=script&lang=ts&"
export * from "./IntervalDetailsTable.vue?vue&type=script&lang=ts&"
import style0 from "./IntervalDetailsTable.vue?vue&type=style&index=0&id=484bee50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484bee50",
  null
  
)

export default component.exports